// Cancel Booking
export const CANCEL_BOOKING_REQUEST = "CANCEL_BOOKING_REQUEST";
export const CANCEL_BOOKING_SUCCESS = "CANCEL_BOOKING_SUCCESS";
export const CANCEL_BOOKING_FAILURE = "CANCEL_BOOKING_FAILURE";

export const cancelBookingRequest = (data: any) => ({
    type: CANCEL_BOOKING_REQUEST,
    payload: data,
});


// Assign Trip
export const ASSIGN_TRIP_REQUEST = "ASSIGN_TRIP_REQUEST";
export const ASSIGN_TRIP_SUCCESS = "ASSIGN_TRIP_SUCCESS";
export const ASSIGN_TRIP_FAILURE = "ASSIGN_TRIP_FAILURE";

export const assignTripRequest = (data: any) => ({
    type: ASSIGN_TRIP_REQUEST,
    payload: data,
});

export const GET_NEW_BOOKINGS_REQUEST = "GET_NEW_BOOKINGS_REQUEST";
export const GET_NEW_BOOKINGS_SUCCESS = "GET_NEW_BOOKINGS_SUCCESS";
export const GET_NEW_BOOKINGS_FAILURE = "GET_NEW_BOOKINGS_FAILURE";

export const getNewBookingsRequest = (branchid: any) => ({
    type: GET_NEW_BOOKINGS_REQUEST,
    payload: branchid,
});

// Get Cancel Reasons
export const GET_CANCEL_REASON_REQUEST = "GET_CANCEL_REASON_REQUEST";
export const GET_CANCEL_REASON_SUCCESS = "GET_CANCEL_REASON_SUCCESS";
export const GET_CANCEL_REASON_FAILURE = "GET_CANCEL_REASON_FAILURE";

export const updateNewBookingRequest = (payload: any) => ({
    type: "UPDATE_NEW_BOOKING_REQUEST",
    payload,
});

export const updateNewBookingSuccess = (data: any) => ({
    type: "UPDATE_NEW_BOOKING_SUCCESS",
    payload: data,
});

export const updateNewBookingFailure = (error: string) => ({
    type: "UPDATE_NEW_BOOKING_FAILURE",
    payload: error,
});

// Auto Assign
export const AUTO_ASSIGN_TRIP_REQUEST = "AUTO_ASSIGN_TRIP_REQUEST";
export const AUTO_ASSIGN_TRIP_SUCCESS = "AUTO_ASSIGN_TRIP_SUCCESS";
export const AUTO_ASSIGN_TRIP_FAILURE = "AUTO_ASSIGN_TRIP_FAILURE";

export const RESET_AUTO_ASSIGN_STATE = "RESET_AUTO_ASSIGN_STATE";

export const autoAssignTripRequest = (payload: any) => ({
    type: AUTO_ASSIGN_TRIP_REQUEST,
    payload,
});

export const autoAssignTripSuccess = (data: any) => ({
    type: AUTO_ASSIGN_TRIP_SUCCESS,
    payload: data,
});

export const autoAssignTripFailure = (error: any) => ({
    type: AUTO_ASSIGN_TRIP_FAILURE,
    payload: error,
});

export const resetAutoAssignState = () => ({
    type: RESET_AUTO_ASSIGN_STATE,
});

export const GET_AVAILABLE_CABS_RADIUS_REQUEST =
    "GET_AVAILABLE_CABS_RADIUS_REQUEST";

export const GET_AVAILABLE_CABS_RADIUS_SUCCESS =
    "GET_AVAILABLE_CABS_RADIUS_SUCCESS";

export const GET_AVAILABLE_CABS_RADIUS_FAILURE =
    "GET_AVAILABLE_CABS_RADIUS_FAILURE";

export const GET_AVAILABLE_CABS_RADIUS_RESET =
    "GET_AVAILABLE_CABS_RADIUS_RESET";

export const getAvailableCabsRadiusRequest = (
    branchid: string,
    vehicletype: number,
    fromlat: string,
    fromlong: string
) => ({
    type: GET_AVAILABLE_CABS_RADIUS_REQUEST,
    payload: {
        branchid,
        vehicletype,
        fromlat,
        fromlong,
    },
});

export const getAvailableCabsRadiusSuccess = (payload: any) => ({
    type: GET_AVAILABLE_CABS_RADIUS_SUCCESS,
    payload,
});

export const getAvailableCabsRadiusFailure = (error: any) => ({
    type: GET_AVAILABLE_CABS_RADIUS_FAILURE,
    payload: error,
});

export const getAvailableCabsRadiusReset = () => ({
    type: GET_AVAILABLE_CABS_RADIUS_RESET,
});

export const GET_SELECTED_CAB_REQUEST = "GET_SELECTED_CAB_REQUEST";
export const GET_SELECTED_CAB_SUCCESS = "GET_SELECTED_CAB_SUCCESS";
export const GET_SELECTED_CAB_FAILURE = "GET_SELECTED_CAB_FAILURE";

export const getSelectedCabRequest = (payload: {
    cabid: string;
    fromlat: string;
    fromlong: string;
}) => ({
    type: GET_SELECTED_CAB_REQUEST,
    payload,
});

export const getSelectedCabSuccess = (payload: any) => ({
    type: GET_SELECTED_CAB_SUCCESS,
    payload,
});

export const getSelectedCabFailure = (error: any) => ({
    type: GET_SELECTED_CAB_FAILURE,
    payload: error,
});

export const RESET_SELECTED_CAB = "RESET_SELECTED_CAB";

export const resetSelectedCab = () => ({
    type: RESET_SELECTED_CAB,
});